export default function Home({ onStart }) {
  return (
    <main className="mx-auto flex min-h-dvh max-w-2xl flex-col items-center px-5 py-2 text-center sm:py-16">
      <p className="text-sm font-bold uppercase tracking-[0.2em] text-showdown-red sm:text-base">
        Aranda Primary School
      </p>
      <p className="mt-1 text-xs font-semibold uppercase tracking-[0.3em] text-showdown-cream/70 sm:text-sm">
        2026 Science Fair &bull; Chemistry
      </p>
      <p className="mt-1 text-xs text-showdown-cream/50 sm:text-sm">Student: Sophie D. (2CWARK)</p>

      <div className="mt-3 h-1 w-16 rounded-full bg-showdown-blue sm:mt-6 sm:h-1.5 sm:w-24" aria-hidden="true" />

      <h1 className="mt-3 font-display text-4xl font-extrabold leading-none tracking-tight sm:mt-6 sm:text-7xl">
        <span className="text-showdown-yellow">SOAP</span>{' '}
        <span className="text-showdown-pink">SHOWDOWN</span>
      </h1>

      <div className="mt-3 h-1 w-16 rounded-full bg-showdown-blue sm:mt-6 sm:h-1.5 sm:w-24" aria-hidden="true" />

      <div className="mt-5 w-full max-w-md overflow-hidden rounded-3xl bg-showdown-ink p-5 shadow-xl sm:mt-8 sm:max-w-xl sm:p-7">
        <div className="aspect-[2190/1365] w-full overflow-hidden rounded-2xl">
          <img
            src="/poster.jpg"
            alt="Soap Showdown science fair poster: two display board panels reading 'How does it work?' and 'The project is... Soap Showdown!', with the research write-up and a QR code linking to the game."
            className="h-full w-full object-cover"
          />
        </div>
      </div>

      <button
        type="button"
        onClick={onStart}
        className="mt-6 w-full max-w-xs whitespace-nowrap rounded-full bg-showdown-pink px-8 py-5 text-xl font-extrabold uppercase tracking-wide text-showdown-ink shadow-lg transition
                   hover:bg-showdown-pink-dark focus-visible:outline focus-visible:outline-4 focus-visible:outline-showdown-yellow active:scale-95 sm:mt-8 sm:max-w-sm sm:text-2xl"
      >
        Start Showdown
      </button>

      <p className="mt-2 text-xs text-showdown-cream/50 sm:mt-6 sm:text-sm">
        Anonymous voting &bull; no names, no accounts, no data about you
      </p>
    </main>
  );
}
